import React, { useContext, useEffect, useState } from "react";
import Navbar from "../../components/navbar/Navbar";
import { FaCheckCircle } from "react-icons/fa";
import { MdReceiptLong } from "react-icons/md";
import { FaCarSide } from "react-icons/fa";
import { CiCreditCard2 } from "react-icons/ci";
import { FaPersonDotsFromLine } from "react-icons/fa6";
import { AiOutlineHome } from "react-icons/ai";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ApplicationContext from "../../ApplicationContext";
import { APPLICATION, BASE_API } from "../../constants";
import Footer from "../../components/footer/Footer";
import LoadingLogo from "../../tools/LoadingLogo";
import ShareButtons from "../../components/share-buttons/ShareButtons";


function OrderComplete(props) {
  const navigate = useNavigate();
  const appContext = useContext(ApplicationContext);

  const [openOrder, setOpenOrder] = useState(false);
  const [orderETA, setOrderETA] = useState("");
  const [orderType, setOrderType] = useState("");
  const [mostRecentOrder, setMostRecentOrder] = useState();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });

    async function getUserOrder() {
      try {
        var userId = appContext.userInfo.userID;
        var response = await axios.get(
          `${BASE_API}api/Order/GetUsersOpenOrders/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${appContext.userInfo.token}`,
              Application: APPLICATION,
            },
          }
        );
        const orders = response.data;
        orders.sort((a, b) => new Date(b.orderedDate) - new Date(a.orderedDate));

        setOrderType(orders[0].orderType);
        if (orders.length >= 1) {
          setMostRecentOrder(orders[0]);

          //IF IT IS A PAID LATER ORDER
          if (orders[0].requestedDate.replace("T", " ") != orders[0].orderedDate.replace("T", " ")) {
            const dateStr = orders[0].requestedDate.replace("T", " ");
            const date = new Date(dateStr);

            const options = {
              month: 'long',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            };

            const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
            setOrderETA(formattedDate);
            setOpenOrder(true);
          } else {
            //ELSE (IT IS NOT A PAID LATER ORDER)
            const currentTimeString = orders[0].requestedDate;
            const currentTime = new Date(currentTimeString);
            const string = orders[0].orderETA;
            const matches = string.match(/\d{2}/g);
            const firstTwoDigits = parseInt(matches[0]);
            const nextTwoDigits = parseInt(matches[1]);

            const newMinTime = new Date(
              currentTime.getTime() + firstTwoDigits * 60000
            );
            const newMaxTime = new Date(
              currentTime.getTime() + nextTwoDigits * 60000
            );

            const hours = newMinTime.getHours() % 12 || 12;
            const minutes = String(newMinTime.getMinutes()).padStart(2, "0");
            const amOrPm = newMinTime.getHours() < 12 ? "AM" : "PM";
            const formattedMinTime = `${hours}:${minutes} ${amOrPm}`;

            const hoursMax = newMaxTime.getHours() % 12 || 12;
            const minutesMax = String(newMaxTime.getMinutes()).padStart(2, "0");
            const amOrPmMax = newMaxTime.getHours() < 12 ? "AM" : "PM";
            const formattedMaxTime = `${hoursMax}:${minutesMax} ${amOrPmMax}`;

            setOrderETA(formattedMinTime + " - " + formattedMaxTime);
            setOpenOrder(true);
          }
        } else {
          navigate("/");
        }
      } catch (error) {
        if (error.response.status === 401) {
          var newAppContext = {
            userInfo: null,
            cart: null,
            cartItems: null,
          };
          props.setAppContext(newAppContext);
          localStorage.setItem("appContext", JSON.stringify(newAppContext));
        }
        toast.error("Your session expired. Please try to login again");
      }
    }
    if (appContext.userInfo) {
      getUserOrder();
    }
  }, []);

  return (
    <>
      <Navbar
        setAppContext={props.setAppContext}
        setAuthKey={props.setAuthKey}
        setShowAuthenticateModal={props.setShowAuthenticateModal}
      />
      {openOrder && mostRecentOrder ? (
        <div className="orderCompletion">
          <div className="head">
            <FaCheckCircle />
            <div className="head_text">
              <div className="success">Success!</div>
              <div className="text">Your order has been placed</div>
            </div>
          </div>
          <div className="thank_you">
            <div className="header">Order Details</div>
            <div className="order_details">
              <div className="detail">
                <MdReceiptLong />
                <div className="text">Order Number: </div>
                <div className="data">{mostRecentOrder.orderNumber}</div>
              </div>

              <div className="detail">
                {mostRecentOrder.orderType === "Delivery" ? (
                  <FaCarSide />
                ) : (
                  <FaPersonDotsFromLine />
                )}
                <div className="text">{mostRecentOrder.orderType} Time: </div>
                <div className="data">
                  {orderType === "Pickup" ? (
                    <div className="">
                      <div className="time">{orderETA}</div>
                    </div>
                  ) : (
                    <div className="">
                      <div className="time">{orderETA}</div>
                    </div>
                  )}
                </div>
              </div>

              {/* {mostRecentOrder.orderType === "Delivery" && (
                <div className="detail">
                  <AiOutlineHome />
                  <div className="text">Address: </div>
                  <div className="data">{mostRecentOrder.orderNumber}</div>
                </div>
              )} */}

              <div className="detail">
                <CiCreditCard2 />
                <div className="text">Payment: </div>
                <div className="data">
                  {mostRecentOrder.payLater === "true" ?
                    (<>{mostRecentOrder.orderType === "Delivery" ? (<>Pay at Delivery</>) : (<>Pay at Pickup</>)}</>) : (<>Paid Online</>)}
                </div>
              </div>
            </div>
          </div>

          <ShareButtons />
        </div>
      ) : (
        <div className="orderCompletion"><LoadingLogo /></div>
      )}
      <Footer />
    </>
  );
}

export default OrderComplete;
